'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('riskModule')

.controller('DepartmentalRiskExportController', ['$scope', '$modal', function ($scope, $modal) {

    $scope.exportCtxt  = {
      environment: environment
    };

    $scope.selectGovernanceProcesses = function () {

        // Modal
        var modalScope = $scope.$new(true);

        var selectModal = $modal({
            scope: modalScope,
            template: '/app/shared/grc/risk/departmentalRisksExportModal.tpl.html',
            placement: 'center'
        });

        modalScope.hideModal = function () {
            selectModal.$promise.then(selectModal.hide);
        }

        modalScope.okModal = function () {
            modalScope.hideModal();
        }

        // Add the selected person
        modalScope.whenExportToReport = function (currentProcess, previousProcess, assessor) {
            var urlToDownload = environment.apiUrl + '/ReportPilot/api/RiskSelfAssessment/GovProcess/From/' +
                                currentProcess.GovernanceProcessID +
                                '/To/' +
                                previousProcess.GovernanceProcessID +
                                '/Assessor/' +
                                assessor.ItemPersonID +
                                '/ExportDepartmentRisksToReport';

            var form = angular.element(document.querySelector('#departmentalRisksToExportForm'));
            form.context.action = urlToDownload;
            form.submit();

            modalScope.okModal();
        }
    }
}]);
